<template>
  <b-sidebar
    :id="id"
    title="Informações visíveis"
    backdrop-variant="dark"
    backdrop
    right
    shadow
  >
    <div class="px-2 py-2">
      <div style="width: 100%" class="p-2">
        <h4 class="text-dark">Colunas customizadas</h4>
        <p>
          Selecione abaixo quais colunas deseja que estejam visíveis na listagem
          de {{ moduleLabel }}
        </p>
      </div>
      <div
        style="width: 100%; max-height: 100%; overflow-y: scroll"
        class="mb-2"
      >
        <div
          v-for="field in customizableFields"
          :key="field.field"
          class="mb-0 ml-5"
        >
          <div style="display: flex; align-items: center; gap: 10px">
            <span class="switch switch-icon">
              <label>
                <input
                  type="checkbox"
                  @change="
                    handleSelectFieldToShow($event.target.checked, field.field)
                  "
                  :checked="isFieldShow(field.field)"
                />
                <span></span>
              </label>
            </span>
            <label :for="field.label" class="mb-0">{{ field.label }}</label>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="d-flex text-light align-items-center px-3 py-2">
        <button
          style="width: 100%"
          class="btn btn-primary btn-hover-dark font-weight-bold"
          @click="$emit('save', localSelectedFields)"
        >
          Salvar
        </button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import _ from "lodash";

export default {
  name: "ColumnVisibilitySidebar",
  props: {
    id: {
      type: String,
      required: true,
    },
    moduleLabel: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    visibleFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localSelectedFields: [],
    };
  },
  computed: {
    customizableFields() {
      return this.fields.filter((field) => field.field !== "actions");
    },
  },
  watch: {
    visibleFields: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localSelectedFields = _.cloneDeep(value);
      },
    },
  },
  methods: {
    isFieldShow(field) {
      return !!this.localSelectedFields.find((el) => el.field === field);
    },
    handleSelectFieldToShow(value, field) {
      const selectedFields = new Set(
        this.localSelectedFields.map((el) => el.field)
      );

      if (value) {
        selectedFields.add(field);
      } else {
        selectedFields.delete(field);
      }

      this.localSelectedFields = _.cloneDeep(
        this.fields.filter(
          (el) => selectedFields.has(el.field) || el.field === "actions"
        )
      );
    },
  },
};
</script>
